import styled from "styled-components";

export const LengthZeroContainer = styled.div`
  ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  .img-processing {
    height: 20.6rem;
    width: 20.1rem;
  }
`;

export const LengthZeroReport = styled.div`
  ${(props) => `
      align-items: center;
      border-radius: 50%;
      display: flex;
      font-family: ${props.theme.fontFamilies.primaryFont};
      height: 11rem;
      justify-content: center;
      margin-top: -12rem;
      position: absolute;
      width: 11rem;
  `}
  .img-processing-report {
    height: 24rem;
    width: 24rem;
  }
`;

export const ColumnZeroReport = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const TitleZeroReport = styled.h1`
  color: #2e353d;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-family: Montserrat;
  font-size: 2rem;
  font-weight: 800;
  margin-top: 9rem;
`;

export const ContentZeroReport = styled.p`
  color: #000000;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.4rem;
  line-height: 2.2rem;
  text-align: center;
  width: 44rem;
`;
